var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingProps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.1314 5.88086H2.59097C2.0432 5.88086 1.59863 6.32545 1.59863 6.87326V18.782C1.59863 19.3298 2.0432 19.7744 2.59097 19.7744H62.1314C62.6791 19.7744 63.1237 19.3298 63.1237 18.782V6.87326C63.1237 6.32545 62.6791 5.88086 62.1314 5.88086Z",
    fill: "#2B86FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55273 21.7593V57.4856C7.55273 58.5822 8.44088 59.4704 9.53741 59.4704H55.185C56.2816 59.4704 57.1697 58.5822 57.1697 57.4856V21.7593H7.55273ZM41.2923 40.6149C41.2923 41.1627 40.8477 41.6073 40.2999 41.6073H24.4225C23.8747 41.6073 23.4302 41.1627 23.4302 40.6149V30.6909C23.4302 30.1431 23.8747 29.6985 24.4225 29.6985H40.2999C40.8477 29.6985 41.2923 30.1431 41.2923 30.6909V40.6149Z",
    fill: "#2B86FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingProps);
export default __webpack_public_path__ + "static/media/pending-props.3a346820fcb9dc090046975263c9d294.svg";
export { ForwardRef as ReactComponent };